import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface ImportantInfoItem {
  id: string;
  title: string;
  title_en?: string;
  content: React.ReactNode;
  content_en?: React.ReactNode;
}

const importantInfoItems: ImportantInfoItem[] = [
  {
    
    id: 'reisetipps',
    title: 'Reisetipps',
    title_en: 'Travel Tips',
    content: (
      <div className="space-y-2.5">
        <div className="flex items-start gap-3">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
            <i className="ri-check-line text-accent-500 text-base" />
          </div>
          <span className="text-sm text-foreground-600 leading-relaxed">Bitte bestellen Sie Ihr Frühstückspaket einen Tag vor dem Ausflug an der Hotelrezeption.</span>
        </div>
        <div className="flex items-start gap-3">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
            <i className="ri-check-line text-accent-500 text-base" />
          </div>
          <span className="text-sm text-foreground-600 leading-relaxed">Stellen Sie Ihren Wecker rechtzeitig oder nutzen Sie den Weckservice Ihres Hotels.</span>
        </div>
        <div className="flex items-start gap-3">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
            <i className="ri-check-line text-accent-500 text-base" />
          </div>
          <span className="text-sm text-foreground-600 leading-relaxed">Bringen Sie Ihren Reisepass oder eine Kopie Ihres Ausweises mit.</span>
        </div>
        <div className="flex items-start gap-3">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
            <i className="ri-check-line text-accent-500 text-base" />
          </div>
          <span className="text-sm text-foreground-600 leading-relaxed">Denken Sie an Sonnenbrille, Kopfbedeckung und Sonnenschutz.</span>
        </div>
        <div className="flex items-start gap-3">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
            <i className="ri-check-line text-accent-500 text-base" />
          </div>
          <span className="text-sm text-foreground-600 leading-relaxed">Tragen Sie bequeme Kleidung und festes Schuhwerk.</span>
        </div>
        <div className="flex items-start gap-3">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
            <i className="ri-check-line text-accent-500 text-base" />
          </div>
          <span className="text-sm text-foreground-600 leading-relaxed">Vergessen Sie Ihre Kamera oder Ihr Smartphone nicht.</span>
        </div>
        <div className="flex items-start gap-3">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
            <i className="ri-check-line text-accent-500 text-base" />
          </div>
          <span className="text-sm text-foreground-600 leading-relaxed">Für persönliche Ausgaben oder optionale Aktivitäten empfehlen wir etwas Bargeld mitzunehmen.</span>
        </div>
        <div className="flex items-start gap-3">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
            <i className="ri-check-line text-accent-500 text-base" />
          </div>
          <span className="text-sm text-foreground-600 leading-relaxed">Kreditkarten werden an vielen Orten akzeptiert, dennoch ist Bargeld oft praktisch.</span>
        </div>
      </div>
    ),
    content_en: (
  <div className="space-y-2.5">
    <div className="flex items-start gap-3">
      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
        <i className="ri-check-line text-accent-500 text-base" />
      </div>
      <span className="text-sm text-foreground-600 leading-relaxed">
        Please order your breakfast package one day before the excursion at the hotel reception.
      </span>
    </div>

    <div className="flex items-start gap-3">
      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
        <i className="ri-check-line text-accent-500 text-base" />
      </div>
      <span className="text-sm text-foreground-600 leading-relaxed">
        Set your alarm in good time or use your hotel's wake-up service.
      </span>
    </div>

    <div className="flex items-start gap-3">
      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
        <i className="ri-check-line text-accent-500 text-base" />
      </div>
      <span className="text-sm text-foreground-600 leading-relaxed">
        Bring your passport or a copy of your ID with you.
      </span>
    </div>

    <div className="flex items-start gap-3">
      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
        <i className="ri-check-line text-accent-500 text-base" />
      </div>
      <span className="text-sm text-foreground-600 leading-relaxed">
        Remember to bring sunglasses, a hat and sun protection.
      </span>
    </div>

    <div className="flex items-start gap-3">
      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
        <i className="ri-check-line text-accent-500 text-base" />
      </div>
      <span className="text-sm text-foreground-600 leading-relaxed">
        Wear comfortable clothing and sturdy shoes.
      </span>
    </div>

    <div className="flex items-start gap-3">
      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
        <i className="ri-check-line text-accent-500 text-base" />
      </div>
      <span className="text-sm text-foreground-600 leading-relaxed">
        Don't forget your camera or smartphone.
      </span>
    </div>

    <div className="flex items-start gap-3">
      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
        <i className="ri-check-line text-accent-500 text-base" />
      </div>
      <span className="text-sm text-foreground-600 leading-relaxed">
        For personal expenses or optional activities, we recommend bringing some cash.
      </span>
    </div>

    <div className="flex items-start gap-3">
      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
        <i className="ri-check-line text-accent-500 text-base" />
      </div>
      <span className="text-sm text-foreground-600 leading-relaxed">
        Credit cards are accepted in many places, but cash is often more practical.
      </span>
    </div>
  </div>
),
  },
  {
    id: 'zahlungsbedingungen',
    title: 'Zahlungsbedingungen',
    title_en: 'Payment Conditions',
    content: (
      <div className="space-y-2.5">
        <div className="flex items-start gap-3">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
            <i className="ri-check-line text-accent-500 text-base" />
          </div>
          <span className="text-sm text-foreground-600 leading-relaxed">Die Bezahlung erfolgt bequem bei der Abholung am Ausflugstag.</span>
        </div>
        <div className="flex items-start gap-3">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
            <i className="ri-check-line text-accent-500 text-base" />
          </div>
          <span className="text-sm text-foreground-600 leading-relaxed">Wir akzeptieren Euro (€), US-Dollar ($) und Ägyptische Pfund (EGP).</span>
        </div>
        <div className="flex items-start gap-3">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
            <i className="ri-check-line text-accent-500 text-base" />
          </div>
          <span className="text-sm text-foreground-600 leading-relaxed">Keine Online-Zahlung erforderlich.</span>
        </div>
        <div className="flex items-start gap-3">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
            <i className="ri-check-line text-accent-500 text-base" />
          </div>
          <span className="text-sm text-foreground-600 leading-relaxed">Keine Anzahlung erforderlich.</span>
        </div>
        <div className="flex items-start gap-3">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
            <i className="ri-check-line text-accent-500 text-base" />
          </div>
          <span className="text-sm text-foreground-600 leading-relaxed">Sie bezahlen direkt vor Ort bei der Abholung.</span>
        </div>
      </div>
    ),
    content_en: (
  <div className="space-y-2.5">
    <div className="flex items-start gap-3">
      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
        <i className="ri-check-line text-accent-500 text-base" />
      </div>
      <span className="text-sm text-foreground-600 leading-relaxed">
        Payment is made conveniently upon pickup on the day of the excursion.
      </span>
    </div>

    <div className="flex items-start gap-3">
      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
        <i className="ri-check-line text-accent-500 text-base" />
      </div>
      <span className="text-sm text-foreground-600 leading-relaxed">
        We accept Euro (€), US Dollar ($) and Egyptian Pound (EGP).
      </span>
    </div>

    <div className="flex items-start gap-3">
      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
        <i className="ri-check-line text-accent-500 text-base" />
      </div>
      <span className="text-sm text-foreground-600 leading-relaxed">
        No online payment is required.
      </span>
    </div>

    <div className="flex items-start gap-3">
      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
        <i className="ri-check-line text-accent-500 text-base" />
      </div>
      <span className="text-sm text-foreground-600 leading-relaxed">
        No deposit is required.
      </span>
    </div>

    <div className="flex items-start gap-3">
      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
        <i className="ri-check-line text-accent-500 text-base" />
      </div>
      <span className="text-sm text-foreground-600 leading-relaxed">
        You pay directly on site upon pickup.
      </span>
    </div>
  </div>
),
  },
  {
    id: 'stornierungsbedingungen',
    title: 'Stornierungsbedingungen',
    title_en: 'Cancellation Conditions',
    content: (
      <div className="space-y-2.5">
        <div className="flex items-start gap-3">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
            <i className="ri-information-line text-foreground-400 text-base" />
          </div>
          <span className="text-sm text-foreground-600 leading-relaxed">Eine kostenfreie Stornierung ist bis 24 Stunden vor Reisebeginn möglich.</span>
        </div>
        <div className="flex items-start gap-3">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
            <i className="ri-information-line text-foreground-400 text-base" />
          </div>
          <span className="text-sm text-foreground-600 leading-relaxed">Bei einer Stornierung weniger als 24 Stunden vor Beginn der Tour bitten wir um eine rechtzeitige Information, da Fahrzeuge, Reiseleiter und organisatorische Leistungen bereits reserviert werden.</span>
        </div>
        <div className="flex items-start gap-3">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
            <i className="ri-information-line text-foreground-400 text-base" />
          </div>
          <span className="text-sm text-foreground-600 leading-relaxed">Bei Nichterscheinen ohne vorherige Absage behalten wir uns vor, zukünftige Buchungsanfragen abzulehnen.</span>
        </div>
        <div className="flex items-start gap-3">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
            <i className="ri-information-line text-foreground-400 text-base" />
          </div>
          <span className="text-sm text-foreground-600 leading-relaxed">Für mehrtägige Touren, Ballonfahrten oder individuell organisierte Sondertouren können bei kurzfristigen Stornierungen unter 24 Stunden bereits entstandene Kosten anfallen.</span>
        </div>
        <div className="flex items-start gap-3">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
            <i className="ri-information-line text-foreground-400 text-base" />
          </div>
          <span className="text-sm text-foreground-600 leading-relaxed">Die genauen Bedingungen werden dem Gast bei der Buchungsbestätigung mitgeteilt.</span>
        </div>
      </div>
    ),
    content_en: (
  <div className="space-y-2.5">
    <div className="flex items-start gap-3">
      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
        <i className="ri-information-line text-foreground-400 text-base" />
      </div>
      <span className="text-sm text-foreground-600 leading-relaxed">
        Free cancellation is possible up to 24 hours before the start of the trip.
      </span>
    </div>

    <div className="flex items-start gap-3">
      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
        <i className="ri-information-line text-foreground-400 text-base" />
      </div>
      <span className="text-sm text-foreground-600 leading-relaxed">
        For cancellations less than 24 hours before the start of the tour, please inform us as early as possible, as vehicles, tour guides and organizational services may already have been reserved.
      </span>
    </div>

    <div className="flex items-start gap-3">
      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
        <i className="ri-information-line text-foreground-400 text-base" />
      </div>
      <span className="text-sm text-foreground-600 leading-relaxed">
        In case of no-show without prior cancellation, we reserve the right to refuse future booking requests.
      </span>
    </div>

    <div className="flex items-start gap-3">
      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
        <i className="ri-information-line text-foreground-400 text-base" />
      </div>
      <span className="text-sm text-foreground-600 leading-relaxed">
        For multi-day tours, balloon rides or individually organized special tours, costs already incurred may apply for cancellations made less than 24 hours before the start.
      </span>
    </div>

    <div className="flex items-start gap-3">
      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
        <i className="ri-information-line text-foreground-400 text-base" />
      </div>
      <span className="text-sm text-foreground-600 leading-relaxed">
        The exact terms and conditions will be communicated to the guest upon booking confirmation.
      </span>
    </div>
  </div>
),
  },
];

export default function ImportantInfo() {
  const [openItem, setOpenItem] = useState<string | null>(null);
  const { i18n } = useTranslation();
const isDe = i18n.language === 'de';

  return (
    <section className="mb-12">
      <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-5">{isDe ? 'Wichtige Informationen' : 'Important Information'}</h2>
      <div className="space-y-3">
        {importantInfoItems.map((item) => (
          <div key={item.id} className="border border-background-200 rounded-sm overflow-hidden">
            <button
              onClick={() => setOpenItem(openItem === item.id ? null : item.id)}
              className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-50 transition-colors"
            >
              <span className="text-sm font-semibold text-foreground-800 pr-4">
                {isDe ? item.title : (item.title_en ?? item.title)}
              </span>
              <i className={`${openItem === item.id ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-foreground-500 flex-shrink-0 text-lg`} />
            </button>
            {openItem === item.id && (
              <div className="px-5 pb-5">
                {isDe ? item.content : (item.content_en ?? item.content)}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}